// DO NOT EDIT -- generated from fs/services/orgs/admin.proto

import { BasePlan, EmbedRole, Interval, OrgID, OrgOrUmbrellaID, Pack, PlanStage, QuotaPeriod, RetentionPeriodUnit, Role, SalesManager, SeatID } from './model.proto';
import { DeprovisionSsoRequest, ProvisionSsoRequest } from './orgs.proto';
import * as flags from '../../shared/flags';
import * as protobuf from '../../../google/protobuf';

export namespace Admin {

  // unsupported streaming endpoint
  export const ListOrgsEndpoint = "/grpc/orgs.Admin/ListOrgs";

  // unsupported streaming endpoint
  export const ListUmbrellasEndpoint = "/grpc/orgs.Admin/ListUmbrellas";

  export const OverrideFlagsEndpoint = "/grpc/orgs.Admin/OverrideFlags";
  /**
   * Override flags.
   * Returns the updated (unmerged) flags
   * Will return an empty response in the case of overriding for a list of IDs.
   * Will return PermissionDenied if not called from an internal admin tool
   */
  export function OverrideFlags(sender: (req: OverrideFlagsRequest, endpoint: string) => Promise<flags.FlagsProto>, req: OverrideFlagsRequest): { promise: () => Promise<flags.FlagsProto>, endpoint: string } {
    return {
      promise: () => sender(req, OverrideFlagsEndpoint),
      endpoint: OverrideFlagsEndpoint
    };
  }

  export const AdminDisableEndpoint = "/grpc/orgs.Admin/AdminDisable";
  /** Will return PermissionDenied if not called from an internal admin tool */
  export function AdminDisable(sender: (req: AdminDisableRequest, endpoint: string) => Promise<{}>, req: AdminDisableRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, AdminDisableEndpoint),
      endpoint: AdminDisableEndpoint
    };
  }

  export const AttachToUmbrellaEndpoint = "/grpc/orgs.Admin/AttachToUmbrella";
  /** Attach existing orgs to an existing Umbrella. */
  export function AttachToUmbrella(sender: (req: AttachToUmbrellaRequest, endpoint: string) => Promise<{}>, req: AttachToUmbrellaRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, AttachToUmbrellaEndpoint),
      endpoint: AttachToUmbrellaEndpoint
    };
  }

  export const UpdateSearchClustersEndpoint = "/grpc/orgs.Admin/UpdateSearchClusters";
  /** Update an org's Solr search clusters. */
  export function UpdateSearchClusters(sender: (req: UpdateSearchClustersRequest, endpoint: string) => Promise<{}>, req: UpdateSearchClustersRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateSearchClustersEndpoint),
      endpoint: UpdateSearchClustersEndpoint
    };
  }

  export const UpdatePlanEndpoint = "/grpc/orgs.Admin/UpdatePlan";
  export function UpdatePlan(sender: (req: UpdatePlanRequest, endpoint: string) => Promise<{}>, req: UpdatePlanRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, UpdatePlanEndpoint),
      endpoint: UpdatePlanEndpoint
    };
  }

  export const UpdatePlanUmbrellaOrgEndpoint = "/grpc/orgs.Admin/UpdatePlanUmbrellaOrg";
  /** UpdatePlanUmbrellaOrg allows callers to update a subset of plan fields for umbrella-orgs. */
  export function UpdatePlanUmbrellaOrg(sender: (req: UpdatePlanUmbrellaOrgRequest, endpoint: string) => Promise<{}>, req: UpdatePlanUmbrellaOrgRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, UpdatePlanUmbrellaOrgEndpoint),
      endpoint: UpdatePlanUmbrellaOrgEndpoint
    };
  }

  export const UpdateInternationalizationEndpoint = "/grpc/orgs.Admin/UpdateInternationalization";
  /** UpdateInternationalization allows callers to update the internationalization settings for an org */
  export function UpdateInternationalization(sender: (req: UpdateInternationalizationRequest, endpoint: string) => Promise<{}>, req: UpdateInternationalizationRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateInternationalizationEndpoint),
      endpoint: UpdateInternationalizationEndpoint
    };
  }

  export const UpdateScheduledOperationsEndpoint = "/grpc/orgs.Admin/UpdateScheduledOperations";
  /**
   * UpdateScheduledOperations allows callers to update the timestamp, for a scheduled operation, for a given org or
   * umbrella.
   */
  export function UpdateScheduledOperations(sender: (req: UpdateScheduledOperationsRequest, endpoint: string) => Promise<{}>, req: UpdateScheduledOperationsRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateScheduledOperationsEndpoint),
      endpoint: UpdateScheduledOperationsEndpoint
    };
  }

  export const RetrieveEmailsEndpoint = "/grpc/orgs.Admin/RetrieveEmails";
  /** Retrieve Emails for a list of orgs of the provided role/roles */
  export function RetrieveEmails(sender: (req: RetrieveEmailsRequest, endpoint: string) => Promise<RetrieveEmailsResults>, req: RetrieveEmailsRequest): { promise: () => Promise<RetrieveEmailsResults>, endpoint: string } {
    return {
      promise: () => sender(req, RetrieveEmailsEndpoint),
      endpoint: RetrieveEmailsEndpoint
    };
  }

  export const FlagsAuditEndpoint = "/grpc/orgs.Admin/FlagsAudit";
  /**
   * Collects data on org flag usage. This is intended to help identify flags that are unused
   * (e.g. 100% of orgs and seats use single value). The response contains details for each
   * flag, other than permission flags.
   */
  export function FlagsAudit(sender: (req: FlagsAuditRequest, endpoint: string) => Promise<FlagsAuditResponse>, req: FlagsAuditRequest): { promise: () => Promise<FlagsAuditResponse>, endpoint: string } {
    return {
      promise: () => sender(req, FlagsAuditEndpoint),
      endpoint: FlagsAuditEndpoint
    };
  }

  export const MigrateLDToPackEndpoint = "/grpc/orgs.Admin/MigrateLDToPack";
  /** MigrateLDToPack will turn a pack on for all orgs, if the given LaunchDarkly flag is enabled. */
  export function MigrateLDToPack(sender: (req: MigrateLDToPackRequest, endpoint: string) => Promise<MigrateLDToPackResponse>, req: MigrateLDToPackRequest): { promise: () => Promise<MigrateLDToPackResponse>, endpoint: string } {
    return {
      promise: () => sender(req, MigrateLDToPackEndpoint),
      endpoint: MigrateLDToPackEndpoint
    };
  }

  export const SendOrgDigestEmailToUserEndpoint = "/grpc/orgs.Admin/SendOrgDigestEmailToUser";
  /** SendOrgDigestEmailToUser will generate a digest email for an org and send it to a specific user. */
  export function SendOrgDigestEmailToUser(sender: (req: SendOrgDigestEmailToUserRequest, endpoint: string) => Promise<{}>, req: SendOrgDigestEmailToUserRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, SendOrgDigestEmailToUserEndpoint),
      endpoint: SendOrgDigestEmailToUserEndpoint
    };
  }

  export const BatchUpdateOrgsLockedEndpoint = "/grpc/orgs.Admin/BatchUpdateOrgsLocked";
  export function BatchUpdateOrgsLocked(sender: (req: BatchUpdateOrgsLockedRequest, endpoint: string) => Promise<BatchUpdateOrgsLockedResponse>, req: BatchUpdateOrgsLockedRequest): { promise: () => Promise<BatchUpdateOrgsLockedResponse>, endpoint: string } {
    return {
      promise: () => sender(req, BatchUpdateOrgsLockedEndpoint),
      endpoint: BatchUpdateOrgsLockedEndpoint
    };
  }

  export const UpdateUmbrellaOrgsLockedEndpoint = "/grpc/orgs.Admin/UpdateUmbrellaOrgsLocked";
  export function UpdateUmbrellaOrgsLocked(sender: (req: UpdateUmbrellaOrgsLockedRequest, endpoint: string) => Promise<BatchUpdateOrgsLockedResponse>, req: UpdateUmbrellaOrgsLockedRequest): { promise: () => Promise<BatchUpdateOrgsLockedResponse>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateUmbrellaOrgsLockedEndpoint),
      endpoint: UpdateUmbrellaOrgsLockedEndpoint
    };
  }

  export const GetAdminLDFlagsEndpoint = "/grpc/orgs.Admin/GetAdminLDFlags";
  export function GetAdminLDFlags(sender: (req: {}, endpoint: string) => Promise<GetAdminLDFlagsResponse>, req: {}): { promise: () => Promise<GetAdminLDFlagsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetAdminLDFlagsEndpoint),
      endpoint: GetAdminLDFlagsEndpoint
    };
  }

  export const GetAdminLDFlagsForOrgEndpoint = "/grpc/orgs.Admin/GetAdminLDFlagsForOrg";
  export function GetAdminLDFlagsForOrg(sender: (req: GetAdminLDFlagsForOrgRequest, endpoint: string) => Promise<GetAdminLDFlagsResponse>, req: GetAdminLDFlagsForOrgRequest): { promise: () => Promise<GetAdminLDFlagsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetAdminLDFlagsForOrgEndpoint),
      endpoint: GetAdminLDFlagsForOrgEndpoint
    };
  }

  export const UpdateRetentionForUmbrellaOrgEndpoint = "/grpc/orgs.Admin/UpdateRetentionForUmbrellaOrg";
  /** Update retention settings for specific umbrella orgs */
  export function UpdateRetentionForUmbrellaOrg(sender: (req: UpdateRetentionForUmbrellaOrgRequest, endpoint: string) => Promise<{}>, req: UpdateRetentionForUmbrellaOrgRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateRetentionForUmbrellaOrgEndpoint),
      endpoint: UpdateRetentionForUmbrellaOrgEndpoint
    };
  }

  export const SyncPersonWithSeatsEndpoint = "/grpc/orgs.Admin/SyncPersonWithSeats";
  /** Removes any orgId's from a person if the person does not have a seat on that org. */
  export function SyncPersonWithSeats(sender: (req: SyncPersonWithSeatsRequest, endpoint: string) => Promise<{}>, req: SyncPersonWithSeatsRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, SyncPersonWithSeatsEndpoint),
      endpoint: SyncPersonWithSeatsEndpoint
    };
  }
}

/**
 * Shared request for listing org or umbrella entities.
 * The type of entity depends on the request endpoint.
 */
export interface ListEntitiesRequest {
  /**
   * The max number of results to return.
   * If 0 or >100, will return all results up to 100.
   */
  limit: number;
  /** Get newest orgs/umbrellas */
  newest?: {} | null;
  /** Get orgs/umbrellas with the exact matching name */
  byName?: string;
  /** Get all orgs/umbrellas for a Person by their email */
  bySeatEmail?: string;
}

/**
 * Shared request for listing org or umbrella entities.
 * The type of entity depends on the request endpoint.
 */
export namespace ListEntitiesRequest {
  export enum criteria {
    /** Get newest orgs/umbrellas */
    newest = 2,
    /** Get orgs/umbrellas with the exact matching name */
    byName = 3,
    /** Get all orgs/umbrellas for a Person by their email */
    bySeatEmail = 4
  }

  export function criteria_oneof(m: ListEntitiesRequest): { opt: criteria.byName, val: string } | { opt: criteria.bySeatEmail, val: string } | { opt: criteria.newest, val: {} } | null {
    if (m.newest != null) { return { opt: criteria.newest, val: m.newest } }
    if (m.byName != null) { return { opt: criteria.byName, val: m.byName } }
    if (m.bySeatEmail != null) { return { opt: criteria.bySeatEmail, val: m.bySeatEmail } }
    return null;
  }
}

export interface OverrideFlagsRequest {
  entityId?: OrgOrUmbrellaID | null;
  /**
   * Option to update multiple orgs/umbrellas
   * Will return an empty response for this case.
   * Max is 100 entities
   */
  entityList?: OverrideFlagsRequest.MultiIDs | null;
  seatId?: SeatID | null;
  /** Update the default flags (for all orgs) */
  defaultAllOrgs?: boolean;
  flagUpdates: OverrideFlagsRequest.FlagUpdate[];
}

export namespace OverrideFlagsRequest {
  export interface MultiIDs {
    ids: OrgOrUmbrellaID[];
  }

  /** Flag overrides can be applied to org, umbrella, or seat depending on the specified ID. */
  export enum id {
    entityId = 1,
    /**
     * Option to update multiple orgs/umbrellas
     * Will return an empty response for this case.
     * Max is 100 entities
     */
    entityList = 6,
    seatId = 3,
    /** Update the default flags (for all orgs) */
    defaultAllOrgs = 5
  }

  /** Flag overrides can be applied to org, umbrella, or seat depending on the specified ID. */
  export function id_oneof(m: OverrideFlagsRequest): { opt: id.defaultAllOrgs, val: boolean } | { opt: id.entityId, val: OrgOrUmbrellaID } | { opt: id.entityList, val: OverrideFlagsRequest.MultiIDs } | { opt: id.seatId, val: SeatID } | null {
    if (m.entityId != null) { return { opt: id.entityId, val: m.entityId } }
    if (m.entityList != null) { return { opt: id.entityList, val: m.entityList } }
    if (m.seatId != null) { return { opt: id.seatId, val: m.seatId } }
    if (m.defaultAllOrgs != null) { return { opt: id.defaultAllOrgs, val: m.defaultAllOrgs } }
    return null;
  }

  export interface FlagUpdate {
    flag: flags.Flag;
    state: OverrideFlagsRequest.FlagState;
  }

  export enum FlagState {
    /** Reset to default */
    DEFAULT = 0,
    /** Force enabled for seat or entity */
    ENABLE = 1,
    /** Force disabled for seat or entity */
    DISABLE = 2
  }
}

export interface AdminDisableRequest {
  orgId: string;
  disabled: boolean;
}

export interface AttachToUmbrellaRequest {
  umbrellaId: string;
  orgId: string;
  /**
   * List of orgs to attach to the Umbrella
   * 
   * @deprecated
   */
  orgIds: string[];
}

export interface UpdateSearchClustersRequest {
  orgId: string;
  /** must be supplied */
  primary: string;
  /** not required if the org should only index and read from a primary cluster */
  secondary: string;
}

/**
 * Feature flags that are additional to the base plan.
 * Should not include packs that are included in the base plan
 * If nil, will leave packs unchanged. If empty list, will clear all add-on packs
 */
export interface SetPacks {
  packs: Pack[];
}

export interface UpdatePlanRequest {
  entityId: OrgOrUmbrellaID | null;
  /** UNSET to leave unchanged */
  basePlan: BasePlan;
  /** UNSET to leave unchanged */
  stage: PlanStage;
  setPacks: SetPacks | null;
  /** Packs to add; incompatible with set_packs */
  enableAddOns: SetPacks | null;
  /** Packs to remove; incompatible with set_packs */
  disableAddOns: SetPacks | null;
  /** The trial expiration date. Ignored if the current or updated stage is not TRIAL or EXPIRED_TRIAL. */
  trialExpiration: protobuf.timestamp | null;
  sessions: protobuf.int64 | null;
  seats: number | null;
  history: number | null;
  alerts: number | null;
  invoiced: boolean | null;
  price: number | null;
  quotaPeriod: QuotaPeriod;
  /**
   * The start date. Will always restart quota if provided.
   * If not provided and quota needs to be reset, will use "now" as the start date.
   * Can only be set if entity is invoiced and active (non-trial).
   * Must be no more than one month in the past and not in the future.
   */
  quotaStart: protobuf.timestamp | null;
  interval: Interval;
  salesManager: SalesManager | null;
  notes: string | null;
  /** The analytics retention in months. Must be a multiple of 12. */
  analyticsHistory: number | null;
  /**
   * This setting is only relevant for free / trial orgs. When set, the only thing it does is
   * allow admins in FSTA to add or edit payment into in the app. This is false by default,
   * meaning that by default free & trial orgs cannot add a payent card.
   */
  allowAddPaymentInfo: boolean | null;
  serverEvents: protobuf.int64 | null;
  changeLogMessage: string | null;
  retentionPeriodUnit: RetentionPeriodUnit;
  /**
   * Determines the percentage of sessions that are "sampled" for FSTA.
   * For example, value of 20 (20%) sample rate will translate to a 80% drop rate within ingestion-settings.
   * Valid values: 0-99, defaults to 0.
   */
  splitProcessingSampleRate: number | null;
}

/** This message should be a subset of UpdatePlanRequest */
export interface UpdatePlanUmbrellaOrgRequest {
  orgId: string;
  setPacks: SetPacks | null;
  changeLogMessage: string | null;
}

export interface UpdateInternationalizationRequest {
  entityId: OrgOrUmbrellaID | null;
  defaultLocale: string | null;
}

export interface UpdateScheduledOperationsRequest {
  entityId: OrgOrUmbrellaID | null;
  clearAll: UpdateScheduledOperationsRequest.ClearOperation | null;
  clearCancellation?: UpdateScheduledOperationsRequest.ClearOperation | null;
  scheduledCancellation?: UpdateScheduledOperationsRequest.ScheduleCancellation | null;
  clearPriceChange?: UpdateScheduledOperationsRequest.ClearOperation | null;
  scheduledPriceChange?: UpdateScheduledOperationsRequest.PriceChange | null;
}

export namespace UpdateScheduledOperationsRequest {
  export interface ClearOperation {
  }

  export interface ScheduleCancellation {
    cancellation: protobuf.timestamp | null;
  }

  export interface PriceChange {
    changeDate: protobuf.timestamp | null;
    price: number | null;
  }

  export enum cancellation_op {
    clearCancellation = 2,
    scheduledCancellation = 3
  }

  export function cancellation_op_oneof(m: UpdateScheduledOperationsRequest): { opt: cancellation_op.clearCancellation, val: UpdateScheduledOperationsRequest.ClearOperation } | { opt: cancellation_op.scheduledCancellation, val: UpdateScheduledOperationsRequest.ScheduleCancellation } | null {
    if (m.clearCancellation != null) { return { opt: cancellation_op.clearCancellation, val: m.clearCancellation } }
    if (m.scheduledCancellation != null) { return { opt: cancellation_op.scheduledCancellation, val: m.scheduledCancellation } }
    return null;
  }

  export enum price_change_op {
    clearPriceChange = 5,
    scheduledPriceChange = 6
  }

  export function price_change_op_oneof(m: UpdateScheduledOperationsRequest): { opt: price_change_op.clearPriceChange, val: UpdateScheduledOperationsRequest.ClearOperation } | { opt: price_change_op.scheduledPriceChange, val: UpdateScheduledOperationsRequest.PriceChange } | null {
    if (m.clearPriceChange != null) { return { opt: price_change_op.clearPriceChange, val: m.clearPriceChange } }
    if (m.scheduledPriceChange != null) { return { opt: price_change_op.scheduledPriceChange, val: m.scheduledPriceChange } }
    return null;
  }
}

export interface RetrieveEmailsRequest {
  orgIds: string[];
  roles: Role[];
}

export interface RetrieveEmailsResults {
  emails: string[];
  errorOrgIds: string[];
}

export interface FlagsAuditRequest {
  /**
   * The set of flags to examine. If omitted/empty, all flags are examined.
   * It is an error to indicate a permission flag in this set; only feature,
   * experiment, and searchie flags are examined.
   */
  flags: flags.Flag[];
}

export interface BackfillTypeRequest {
  /**
   * Must be a valid Datastore kind listed in kinds.go.
   * Not all types are supported but can be easily added.
   */
  kind: string;
}

export interface BackfillTypeResponse {
  /** This ID can be used to lookup and check the status of the request */
  processId: string;
}

export interface FlagsAuditResponse {
  /** The actual details for stats about which org flags are in use and where. */
  flagStats: FlagsAuditResponse.FlagStats[];
}

export namespace FlagsAuditResponse {
  export interface FlagStats {
    /** The actual flag whose stats are herein. */
    flag: flags.Flag;
    /**
     * True if flag is a known value in the enum; false should mean an
     * old, now-deleted flag.
     */
    known: boolean;
    /**
     * The default value for this flag. The default comes from the
     * AppCounters entity in datastore. (Any flag not present there
     * implicitly defaults to zero.)
     */
    defaultValue: number;
    /** Stats on each observed value for the flag. */
    valueStats: FlagsAuditResponse.FlagStats.ValStats[];
  }

  export namespace FlagStats {
    export interface ValStats {
      /**
       * The actual value whose stats are herein. (Values are generally
       * zero or one, but it is possible for them to be any int32 value.)
       */
      value: number;
      /** The number of orgs that have this value for the current flag. */
      numOrgs: number;
      /**
       * The actual org IDs, if less than 100. If 100 or more, then
       * only the count of org IDs (num_orgs) is populated.
       */
      orgIds: string[];
      /**
       * The number of orgs that contain seats that override their org's
       * default value with this value.
       */
      numOrgsWithSeatOverrides: number;
      /**
       * The number of seats that override their org's default value with
       * this value.
       */
      numSeatOverrides: number;
      /**
       * The actual org IDs with seat overrides, if less than 100. If
       * more than 100 then only the count (num_orgs_with_seat_overrides)
       * is populated.
       */
      seatOverridesByOrgId: { [key: string]: FlagsAuditResponse.FlagStats.ValStats.SeatOverrides };
    }

    export namespace ValStats {
      export interface SeatOverrides {
        /** The number of overrides just for a single org. */
        numSeatOverrides: number;
        /**
         * The actual overriding seats (email addresses), if less than 100.
         * If more than 100 then only the count (num_seat_overrides) will
         * be populated.
         */
        seatOverrides: string[];
      }
    }
  }
}

/** LegacyProvisionSsoRequest is a wrapper around ProvisionSsoRequest, with some additional options. */
export interface LegacyProvisionSsoRequest {
  /** team_name represents an existing SSO connection for the org to be hooked up to */
  teamName: string;
  provisionSsoRequest: ProvisionSsoRequest | null;
}

/** LegacyDeprovisionSsoRequest is a wrapper around DeprovisionSsoRequest. */
export interface LegacyDeprovisionSsoRequest {
  deprovisionSsoRequest: DeprovisionSsoRequest | null;
}

export interface MigrateLDToPackRequest {
  launchDarklyFlag: string;
  pack: Pack;
  dryRun: boolean;
}

export interface MigrateLDToPackResponse {
  /** This ID can be used to lookup and check the status of the request */
  processId: string;
}

export interface SendOrgDigestEmailToUserRequest {
  /** The org to generate digest email for. */
  orgId: OrgID | null;
  /** The user to receive the digest email. */
  email: string;
  /** A unix timestamp indicating the end boundary for the time range in which the digest email will be generated. */
  endTime: protobuf.int64;
  /** Optional debug_freq forces a frequency mode. Empty means use whatever the user has set. */
  debugFreq: SendOrgDigestEmailToUserRequest.Frequency;
}

export namespace SendOrgDigestEmailToUserRequest {
  export enum Frequency {
    UNKNOWN = 0,
    DAILY = 1,
    WEEKLY = 2
  }
}

export interface BatchUpdateOrgsLockedRequest {
  orgIds: string[];
  lock: boolean;
}

export interface BatchUpdateOrgsLockedResponse {
  /** orgIds to error messages */
  errors: { [key: string]: string };
}

export interface GenerateEmbedPartnerUserApiKeyRequest {
  embedPartnerId: string;
  seatEmail: string;
  name: string;
  role: EmbedRole;
}

export interface GenerateEmbedPartnerUserApiKeyResponse {
  apiKey: string;
  suffix: string;
}

export interface GetAdminLDFlagsResponse {
  flags: { [key: string]: boolean };
}

export interface GetAdminLDFlagsForOrgRequest {
  orgId: string;
}

export interface ClearTeamDataRequest {
  teamName: string;
}

export interface UpdateUmbrellaOrgsLockedRequest {
  umbrellaId: string;
  lock: boolean;
}

export interface UpdateRetentionForUmbrellaOrgRequest {
  orgId: string;
  history?: number | null;
  removeReplay?: boolean;
  analyticsHistory?: number | null;
  removeAnalytics?: boolean;
}

export namespace UpdateRetentionForUmbrellaOrgRequest {
  export enum replay {
    history = 2,
    removeReplay = 3
  }

  export function replay_oneof(m: UpdateRetentionForUmbrellaOrgRequest): { opt: replay.history, val: number } | { opt: replay.removeReplay, val: boolean } | null {
    if (m.history != null) { return { opt: replay.history, val: m.history } }
    if (m.removeReplay != null) { return { opt: replay.removeReplay, val: m.removeReplay } }
    return null;
  }

  export enum analytics {
    analyticsHistory = 4,
    removeAnalytics = 5
  }

  export function analytics_oneof(m: UpdateRetentionForUmbrellaOrgRequest): { opt: analytics.analyticsHistory, val: number } | { opt: analytics.removeAnalytics, val: boolean } | null {
    if (m.analyticsHistory != null) { return { opt: analytics.analyticsHistory, val: m.analyticsHistory } }
    if (m.removeAnalytics != null) { return { opt: analytics.removeAnalytics, val: m.removeAnalytics } }
    return null;
  }
}

export interface SyncPersonWithSeatsRequest {
  email: string;
}
